module.exports = __webpack_public_path__ + "static/media/kb-ambassador-en.07419d62.png";